import React, { useState } from "react";

import { RushCharge } from "./rushCharge";
import { TimeCharge } from "./timeCharge";
import { Title } from "./title";
import { Toggler } from "./toggler";
import styled from "styled-components";
import { Qualification } from "@src/appV2/Admin/Qualifications/types";

const Container = styled.div`
  > .content {
    display: none;
    &.show {
      display: block;
      margin-left: 20px;
    }
  }
`;

interface ShiftChargeProps {
  hcfId: string;
  hcfType: string;
  updateFacility: (data: unknown) => Promise<unknown>;
  qualifications: Qualification[];
}

function ShiftCharge({ hcfId, hcfType, updateFacility, qualifications }: ShiftChargeProps) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [extend, setExtend] = useState<any>(false);
  const toggle = () => {
    setExtend(!extend ? "show" : "");
  };

  return (
    <Container>
      <Title>
        Shift Charges
        <Toggler extend={extend} onClick={toggle} />
      </Title>
      <div className={`content${extend ? " show" : ""}`}>
        <RushCharge hcfId={hcfId} updateFacility={updateFacility} />
        <TimeCharge
          hcfId={hcfId}
          hcfType={hcfType}
          updateFacility={updateFacility}
          qualifications={qualifications}
        />
      </div>
    </Container>
  );
}

export { ShiftCharge };
